import React from "react";
import { MessageCircle, Mail, Facebook, MapPin, Video } from "lucide-react";
import { BRAND } from "../../lib/constants";

export default function Contact() {
    const items = [
        {
            icon: MessageCircle,
            label: "WhatsApp",
            value: BRAND.whatsappDisplay,
            href: `https://wa.me/${BRAND.whatsapp.replace("+", "")}`,
            testid: "contact-whatsapp",
        },
        {
            icon: Mail,
            label: "Email",
            value: BRAND.email,
            href: `mailto:${BRAND.email}`,
            testid: "contact-email",
        },
        {
            icon: Facebook,
            label: "Facebook",
            value: "/YASHPALMOMIA",
            href: BRAND.facebook,
            testid: "contact-facebook",
        },
        {
            icon: Video,
            label: "Zoom Room",
            value: "Join meeting now",
            href: BRAND.zoomUrl,
            testid: "contact-zoom",
        },
    ];
    return (
        <section
            id="contact"
            className="py-24 md:py-32"
            data-testid="contact-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-12 gap-12 items-end mb-16">
                    <div className="md:col-span-7">
                        <div className="overline mb-4">07 / Contact</div>
                        <h2 className="font-cabinet font-bold text-4xl md:text-5xl leading-[1.05] tracking-tight text-ink">
                            Talk to our export desk,
                            <br />
                            <span className="italic font-normal text-[#4D7C0F]">
                                on your channel.
                            </span>
                        </h2>
                    </div>
                    <div className="md:col-span-5">
                        <div className="flex items-start gap-3 text-stone-700">
                            <MapPin
                                size={18}
                                strokeWidth={1.5}
                                className="mt-1 text-[#0C4A6E]"
                            />
                            <div className="text-base">
                                <div className="font-mono text-xs uppercase tracking-[0.18em] text-stone-500 mb-1">
                                    Headquartered
                                </div>
                                India · Exporting worldwide
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    {items.map((it) => (
                        <a
                            key={it.label}
                            href={it.href}
                            target="_blank"
                            rel="noreferrer"
                            className="group bg-white border border-stone-200 p-7 hover:border-[#0C4A6E] hover:bg-[#0C4A6E] hover:text-white transition-all"
                            data-testid={it.testid}
                        >
                            <it.icon
                                size={26}
                                strokeWidth={1.5}
                                className="mb-6 text-[#0C4A6E] group-hover:text-white transition-colors"
                            />
                            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500 group-hover:text-sky-200 transition-colors">
                                {it.label}
                            </div>
                            <div className="mt-1 font-cabinet font-bold text-xl tracking-tight">
                                {it.value}
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
